class ItemListModel {
  constructor(data = {
    description: null,
    name: null,
    private: false,
  }) {
      this.description = data.description;
      this.name = data.name;
      this.private = data.private;
  }
}

export default ItemListModel;
